export default __webpack_public_path__ + "static/media/sunsculpted15.43dc83b3.jpg";